import React, { useEffect, useState } from 'react';
import profileImg from '../Images/sharjeel baig.PNG';
import htmlImg from '../Images/html5.png';
import csImg from '../Images/Cs.png';
import cssImg from '../Images/css.png';
import jsImg from '../Images/javascript.png';
import javaImg from '../Images/java.png';
import pythonImg from '../Images/python.png';
import { motion } from "framer-motion";
import ImageViewer from './imageViewer';
import { Link } from 'react-router-dom';
import ImageView from '../components/Image';
import ProgrammingLanguage from '../components/ProgrammingLanguage';


const Home = () => {
   function afterSomeTime(functionToPerform) {
      setTimeout(
         functionToPerform
      , 1);
   }

   const [programmingLanguage,setProgrammingLanguage] = useState();
  

    return ( 
      <div id="home" >
 {/* //first div   */}
       <motion.div
       id="div1"
       >
        {/* intro */}
        
        <div className="introDiv">
           {/* <div>
              <div style={{ width:'130px'}} className='imageOptions'>
                 <center>
 <Link to="/imageViewer">
<button>
   View
</button>
</Link>
<button>
 about image
</button>
</center>
              </div>
<motion.img   
    transition={{ duration: 1,}}
    drag="x"
  dragConstraints={{ left:1,right: 100, }}
  whileTap={{scale:2}}
     className="profileImg" src={profileImg} />
</div> */}

<ImageView setImage="SharjeelBaigProfile" className="profileImg" src={profileImg} height="100px" width="130px" />

<center>
<div className="introNameAndTitle">
<h3>Sharjeel Baig</h3>
<p>The programming wizard</p>


</div>
</center>
</div>

<br />
<br />

{/* Rest */}
<div className="restContentsOfBody">
<p> hello, I am Muhammad Sharjeel Baig, a full-stack developer </p>
<br />
{/* my Skills */}
<div className="lightDiv">

<div>
<p>My programming skills are as follows:</p>
</div>

<div className="programmingLanguages">
<motion.img whileTap={{scale:0.5}}  className="programmingLanguageLogo" onTap={()=>{afterSomeTime(()=>{window.location.href = '#htmlDiv'}); setProgrammingLanguage(<ProgrammingLanguage id="htmlDiv" languageName = "Html" src={htmlImg} description="A simple web designing language which is easy to learn and easily readable"  />)}} 
onClick={()=>{afterSomeTime(()=>{window.location.href = '#htmlDiv'}); setProgrammingLanguage(<ProgrammingLanguage id="htmlDiv" languageName = "Html" src={htmlImg} description="A simple web designing language which is easy to learn and easily readable"  />)}}
src={htmlImg} />
<motion.img whileTap={{scale:0.5}}   className="programmingLanguageLogo" onClick={()=>{afterSomeTime(()=>{window.location.href = '#cssDiv'}); setProgrammingLanguage(<ProgrammingLanguage id="cssDiv" languageName = "Css" src={cssImg} description="A simple language used for styling web sites"  />)}}
onTap={()=>{afterSomeTime(()=>{window.location.href = '#cssDiv'}); setProgrammingLanguage(<ProgrammingLanguage id="cssDiv" languageName = "Css" src={cssImg} description="A simple language used for styling web sites"  />)}}
src={cssImg} />
<motion.img whileTap={{scale:0.5}}   className="programmingLanguageLogo" onClick={()=>{afterSomeTime(()=>{window.location.href = '#jsDiv'}); setProgrammingLanguage(<ProgrammingLanguage id="jsDiv" languageName = "Javascipt" src={jsImg} description="A very powerful programming language which can be used for many purposes,from building a website dynamic to making apps and games for pc and mobiles. javascript is the best language to choose for becoming a professional programmer"  />)}}
onTap={()=>{afterSomeTime(()=>{window.location.href = '#jsDiv'}); setProgrammingLanguage(<ProgrammingLanguage id="jsDiv" languageName = "Javascipt" src={jsImg} description="A very powerful programming language which can be used for many purposes,from building a website dynamic to making apps and games for pc and mobiles. javascript is the best language to choose for becoming a professional programmer"  />)}}
src={jsImg} />
<motion.img whileTap={{scale:0.5}}  className="programmingLanguageLogo" onClick={()=>{afterSomeTime(()=>{window.location.href = '#csDiv'}); setProgrammingLanguage(<ProgrammingLanguage id="csDiv" languageName = "C#" src={csImg} description="C#, the best backend programming language in my opinion.It is the most reliable language to choose for full-stack developers.However it is not easy and difficult to understand but learning this language from basics to advance can make you a better full-stack developer "  />)}}
onTap={()=>{afterSomeTime(()=>{window.location.href = '#csDiv'}); setProgrammingLanguage(<ProgrammingLanguage id="csDiv" languageName = "C#" src={csImg} description="C#, the best backend programming language in my opinion.It is the most reliable language to choose for full-stack developers.However it is not easy and difficult to understand but learning this language from basics to advance can make you a better full-stack developer "  />)}}
src={csImg} />
<motion.img whileTap={{scale:0.5}}  className="programmingLanguageLogo" onClick={()=>{afterSomeTime(()=>{window.location.href = '#javaDiv'}); setProgrammingLanguage(<ProgrammingLanguage id="javaDiv" languageName = "Java" src={javaImg} description="Java is a powerful language and it is similiar to c# but in some cases it so different from it. And the purpose to learn this language is actually distinguishable from C#.Java is used mostly for Android Development wherease C# can be used for backend works of any WebSite.But however, Java can also do backend works because it is a backend language,java and C# can do similiar work but most developers give preference to C# in backend works."  />)}}
onTap={()=>{afterSomeTime(()=>{window.location.href = '#javaDiv'}); setProgrammingLanguage(<ProgrammingLanguage id="javaDiv" languageName = "Java" src={javaImg} description="Java is a powerful language and it is similiar to c# but in some cases it so different from it. And the purpose to learn this language is actually distinguishable from C#.Java is used mostly for Android Development wherease C# can be used for backend works of any WebSite.But however, Java can also do backend works because it is a backend language,java and C# can do similiar work but most developers give preference to C# in backend works."  />)}}
src={javaImg} />
<motion.img whileTap={{scale:0.5}}  className="programmingLanguageLogo" onClick={()=>{afterSomeTime(()=>{window.location.href = '#pythonDiv'}); setProgrammingLanguage(<ProgrammingLanguage id="pythonDiv" languageName = "Python" src={pythonImg} description="A high level backend programming language, its context is user friendly and it is very easy to learn.its clean code is so easy to read and understand. anyone who starts learning it can master this programming language easily.It is a better option to choose as a beginner programmer for becomming a professional highly paid programmer. "/>)}}
onTap={()=>{afterSomeTime(()=>{window.location.href = '#pythonDiv'}); setProgrammingLanguage(<ProgrammingLanguage id="pythonDiv" languageName = "Python" src={pythonImg} description="A high level backend programming language, its context is user friendly and it is very easy to learn.its clean code is so easy to read and understand. anyone who starts learning it can master this programming language easily.It is a better option to choose as a beginner programmer for becomming a professional highly paid programmer. "/>)}}
src={pythonImg} />
</div>

<div style={{flexWrap:'wrap'}}>
   <br />
   {programmingLanguage}
  
</div>

</div>
</div>

</motion.div>
{/* //end of first div */}


















{/* some spaces to seperate footer and the contents of body */}
<br />
  <br />
  <br />
  <br />
 










     </div>

     );
}
 
export default Home;